<template>
  <RouterView />
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router'
import { onMounted } from 'vue'
import { useFeatureFlagsStore } from '@/stores/useFeatureFlagsStore'
import { clientPortalConfig } from '@/config/clientPortalConfig'

var featureFlagsStore = useFeatureFlagsStore()

onMounted(async () => {
  if (clientPortalConfig.gtmId) {
    var script = document.createElement('script')
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${clientPortalConfig.gtmId}');`
    document.head.appendChild(script)
  }
  await featureFlagsStore.load()
})
</script>
